module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-440.4981c4d.woff2";